// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V8xog","left":"styles_left__363-z","right":"styles_right__3y380","alert":"styles_alert__2hNu1"};